import {Theme} from "@mui/material/styles";
import defaultTheme from "./default.tsx";
import anthraciteTheme from "./anthracite.ts";

export type ThemeName = 'default' | 'anthracite'

export const themes = new Map<ThemeName, Theme>([
    ["default", defaultTheme],
    ["anthracite", anthraciteTheme],
])
